import { render, staticRenderFns } from "./QuestionTime.vue?vue&type=template&id=538f7ffa&scoped=true&"
import script from "./QuestionTime.vue?vue&type=script&lang=js&"
export * from "./QuestionTime.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTime.vue?vue&type=style&index=0&id=538f7ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538f7ffa",
  null
  
)

export default component.exports